import { render } from "./UCSortPopover.vue?vue&type=template&id=edca4de8"
import script from "./UCSortPopover.vue?vue&type=script&lang=js"
export * from "./UCSortPopover.vue?vue&type=script&lang=js"

import "./UCSortPopover.vue?vue&type=style&index=0&id=edca4de8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__